"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var CardTextWrapper = function CardTextWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _this.onOpenArrowBox = function () {
        _state.DeckUI.designateUiElementAsSeen('revealed_text');
      };
      _this.revealText = function () {
        var _this$props$card, _DeckUI$deck, _this$props$card2, _this$props$card3;
        _state.DeckUI.createEvent('deck - click reveal text icon', {
          language_id: ((_this$props$card = _this.props.card) === null || _this$props$card === void 0 ? void 0 : _this$props$card.languageId) || ((_DeckUI$deck = _state.DeckUI.deck) === null || _DeckUI$deck === void 0 ? void 0 : _DeckUI$deck.languageId),
          card_type_id: ((_this$props$card2 = _this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.cardType) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.id) || ((_this$props$card3 = _this.props.card) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.cardTypeId)
        });
        _state.DeckUI.revealText(_this.props.card, _this.props.cardState);
      };
      _this.onToggleSourceEditExpanded = function () {
        _state.OverlayUI.addOverlay('sourceEdit', {
          card: _this.props.card,
          sentence: _this.props.card.sentence
        });
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "showText",
      get: function get() {
        return this.props.showText || _state.DeckUI.textRevealed;
      }
    }, {
      key: "height",
      get: function get() {
        if (this.props.height) {
          return this.props.height;
        }
        if (this.props.showHelp) {
          return _state.DeckUI.layout.userInputHeight + _state.DeckUI.layout.cardTextHeight;
        }
        if (this.props.expand) {
          return _state.DeckUI.layout.contentHeight - _state.DeckUI.layout.userInputHeight;
        }
        if (!this.props.hasUserInput) {
          return _state.DeckUI.layout.cardTextHeight + _state.DeckUI.layout.userInputHeight;
        }
        return _state.DeckUI.layout.cardTextHeight;
      }
    }, {
      key: "width",
      get: function get() {
        if (this.props.width) {
          return this.props.width;
        }
        return _state.DeckUI.layout.deckWidth - 40;
      }
    }, {
      key: "showSentenceBreakdown",
      get: function get() {
        return this.props.sentence && this.props.sentence.state && !this.props.showHelp;
      }
    }, {
      key: "literalSource",
      get: function get() {
        var _this$props$card4;
        if (typeof ((_this$props$card4 = this.props.card) === null || _this$props$card4 === void 0 || (_this$props$card4 = _this$props$card4.translation) === null || _this$props$card4 === void 0 ? void 0 : _this$props$card4.literalSourceForUser) === 'function') {
          return this.props.card.translation.literalSourceForUser(_state.DeckUI.user);
        }
      }
    }, {
      key: "showLiteralSource",
      get: function get() {
        return this.props.showType === 'source' && !this.props.cardState.revealed && this.props.cardState.helpWasShown && this.sourceText !== this.literalSource;
      }
    }, {
      key: "showRevealTextIcon",
      get: function get() {
        return !this.props.cardState.revealed && (this.props.card.comprehendCard && _state.DeckUI.canRecordMedia || this.props.card.answerCard);
      }
    }, {
      key: "sourceText",
      get: function get() {
        if (this.props.card && this.props.sentence && (0, _utils.isPresent)(this.props.sentence.sourceTextForUser(_state.DeckUI.user))) {
          return this.props.sentence.sourceTextForUser(_state.DeckUI.user);
        } else if (this.props.sentence && this.props.sentence.sourceText) {
          return this.props.sentence.sourceText;
        }
        return this.props.card.frontText;
      }
    }, {
      key: "hasUserLanguageTranslation",
      get: function get() {
        return this.props.card && this.props.sentence && (0, _utils.isPresent)(this.props.sentence.sourceTextForUser(_state.DeckUI.user));
      }
    }, {
      key: "simpleTextMode",
      get: function get() {
        var _this$props$card$sent;
        return this.props.card && (0, _utils.isBlank)((_this$props$card$sent = this.props.card.sentence) === null || _this$props$card$sent === void 0 ? void 0 : _this$props$card$sent.wordAssociations);
      }
    }, {
      key: "customText",
      get: function get() {
        return this.props.cardState.revealed ? this.props.card.backText : this.props.card.frontText;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          loadHelpWord: this.loadHelpWord,
          height: this.height,
          width: this.width,
          showSentenceBreakdown: this.showSentenceBreakdown,
          literalSource: this.literalSource,
          showLiteralSource: this.showLiteralSource,
          sourceText: this.sourceText,
          customText: this.customText,
          onToggleText: this.onToggleText,
          onOpenArrowBox: this.onOpenArrowBox,
          revealText: this.revealText,
          showText: this.showText,
          showRevealTextIcon: this.showRevealTextIcon,
          simpleTextMode: this.simpleTextMode,
          onToggleSourceEditExpanded: this.onToggleSourceEditExpanded,
          hasUserLanguageTranslation: this.hasUserLanguageTranslation
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "showText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "height", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "height"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "width", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "width"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSentenceBreakdown", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSentenceBreakdown"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "literalSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "literalSource"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showLiteralSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showLiteralSource"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showRevealTextIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showRevealTextIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sourceText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sourceText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasUserLanguageTranslation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasUserLanguageTranslation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "simpleTextMode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "simpleTextMode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "customText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "customText"), _class2.prototype), _class2)) || _class;
};
CardTextWrapper.displayName = 'CardTextWrapper';
var _default = exports["default"] = CardTextWrapper;